<template>
    <div class="ma-3">
        <!-- v-if="currentTime && currentTime < targetTime" -->

        <!-- <v-col cols="12"> -->
        <!-- <SickLeaveCountdown /> -->
        <!-- </v-col> -->

        <!-- <v-col cols="12"> -->
        <!-- <JoinBriefing /> -->
        <!-- </v-col> -->

        <!-- <v-col cols="12"> -->
        <!-- <LeaveCarryForward /> -->
        <!-- </v-col> -->


        <v-row>
            <v-col cols="12" md="6" lg="4">
                <DateCard />
            </v-col>

            <v-col cols="12" md="6" lg="8">
                <NoticeCard />
            </v-col>

            <v-col cols="12" v-show="pendingTrainingCount > 0">
                <PendingTrainingsCard @loaded="count => pendingTrainingCount = count" />
            </v-col>

            <v-col cols="12" v-show="trainingProgressCount > 0">
                <TrainingProgressCard @loaded="count => trainingProgressCount = count" />
            </v-col>

            <v-col cols="12">
                <v-alert dir="rtl" class="dhivehi" type="info" prominent text>
                    <div class="d-flex justify-space-between align-center">
                        <span class="mr-5" style="font-size: 18px;">
                            ގަވާއިދު ނަންބަރު <bdi>2026/R-81</bdi>: ޕްރޮސިކިއުޓަރ ޖެނެރަލްގެ އޮފީހުގެ މުވައްޒަފުންގެ
                            ގަވާއިދު
                        </span>
                        <a href="https://pgoffice.gov.mv/storage/media/8ec7d6be-f9ea-4d21-b8df-2a17f85b9784.pdf"
                            target="_blank">
                            <v-icon color="info">mdi-open-in-new</v-icon>
                        </a>
                    </div>
                </v-alert>
            </v-col>

            <v-col cols="12">
                <v-card class="pa-4">
                    <doc-panel model-type="system" :model-id="1" :can-edit="$can('all_permissions')" open-in-page />
                </v-card>
            </v-col>

            <v-col cols="12" v-if="!loading && newHires && newHires.length">
                <!-- <v-row dense justify="center">
            <v-col v-for="staff in newHires" :key="staff.ISMID" cols="12" lg="3" md="4" sm="6">
              <div  :id="`captureEl${staff.ISMID}`" class="text-center new-hire-card" @click="downloadPng(`captureEl${staff.ISMID}`)">
                <div class="py-6">

                  <div class="mb-4">
                    <img width="35" src="../../assets/logo-only.png" />
                  </div>
                  <div class="font-weight-black text-uppercase mb-1 pg_eng" style="font-size: 25px;">
                    Welcome
                  </div>
                  <div class=" text-uppercase pg_eng">
                    to prosecutor generals office
                  </div>

                  <div class="my-8">
                      <img
                        :src="staff.profile_image"
                        :alt="staff.LcEngStaffName + ' profile image'"
                        style="border-radius: 10%;"
                        width="100"
                      >
                  </div>

                  <div class="font-weight-bold pg_eng" style="font-size: 20px;">
                    {{ staff.LcEngStaffName }}
                  </div>
                  <div class="pg_eng">
                    {{ staff.EngPosition }}
                  </div>
                  <div class="pg_eng">
                    {{ staff.EngSectionName }}
                  </div>

                </div>

                <img width="100%" src="../../assets/footer.png" />
              </div>

            </v-col>
          </v-row> -->
                <div class="welcome-banner text-center pg_eng mb-4">
                    <!-- <div class="mb-2">
              <img width="40" src="../../assets/logo-only.png" />
            </div> -->
                    <div class="font-weight-black text-uppercase" style="font-size: 28px; line-height: 1.1;">
                        Welcome
                    </div>
                    <div class="text-uppercase" style="font-size: 16px;">
                        to prosecutor generals office
                    </div>
                </div>

                <v-row dense justify="center">
                    <v-col v-for="staff in newHires" :key="staff.ISMID" cols="6" sm="4" md="3" lg="2">
                        <v-card class="new-hire-card-small pg_eng pa-3 d-flex align-center" color="white"
                            :style="{ cursor: $can('hrms') ? 'pointer' : 'default' }"
                            @click="downloadPng(`captureEl${staff.ISMID}`)" rounded="lg">
                            <v-avatar size="56" class="mr-3">
                                <img :src="staff.profile_image" :alt="staff.LcEngStaffName + ' profile image'" />
                            </v-avatar>
                            <div class="text-left" style="min-width: 0;">
                                <div class="font-weight-bold text-truncate" style="font-size: 14px;">
                                    {{ staff.LcEngStaffName }}
                                </div>
                                <div class="text-truncate" style="font-size: 12px;">
                                    {{ staff.EngPosition }}
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </v-row>

                <div class="capture-offscreen" aria-hidden="true">
                    <div v-for="staff in newHires" :key="`cap-${staff.ISMID}`" :id="`captureEl${staff.ISMID}`"
                        class="text-center new-hire-card" style="width: 360px;">
                        <div class="py-6">

                            <div class="mb-4">
                                <img width="35" src="../../assets/logo-only.png" />
                            </div>
                            <div class="font-weight-black text-uppercase mb-1 pg_eng" style="font-size: 25px;">
                                Welcome
                            </div>
                            <div class=" text-uppercase pg_eng">
                                to prosecutor generals office
                            </div>

                            <div class="my-8">
                                <img :src="staff.profile_image" :alt="staff.LcEngStaffName + ' profile image'"
                                    style="border-radius: 10%;" width="100">
                            </div>

                            <div class="font-weight-bold pg_eng" style="font-size: 20px;">
                                {{ staff.LcEngStaffName }}
                            </div>
                            <div class="pg_eng">
                                {{ staff.EngPosition }}
                            </div>
                            <div class="pg_eng">
                                {{ staff.EngSectionName }}
                            </div>

                        </div>

                        <img width="100%" src="../../assets/footer.png" />
                    </div>
                </div>
            </v-col>

            <v-col cols="12">
                <active-polls ref="activePolls" />
            </v-col>

            <v-col cols="12" md="12" lg="12">
                <MemoCard />
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <MyDayCard />
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <WfhEligibilityCard />
            </v-col>

            <v-col cols="12" md="6" lg="4" v-show="wfhToday">
                <WfhDayCard @loaded="v => wfhToday = v" />
            </v-col>

            <v-col v-if="$can('all_permissions')" cols="12" md="6" lg="4">
                <ManagerSummaryCard />
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <MyEvents />
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <PendingApprovalCount />
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <TodaysMeetingsCard />
            </v-col>

            <v-col cols="12" md="6" lg="4">
                <AvailableRoomsCard />
            </v-col>

            <!-- <v-col cols="12" md="6" lg="4">
        <AttendanceRequests />
      </v-col> -->

        </v-row>

        <v-row>
            <!-- <v-col cols="12" md="6">
        <MemoCard />
      </v-col> -->


        </v-row>




        <!-- charts: leaves, work/break time -->

        <!-- <v-col cols="12" sm="12">
      <MemoTable />
    </v-col> -->

        <!-- <h1>Dashboard</h1> -->
    </div>
</template>

<script>
import SickLeaveCountdown from './SickLeaveCountdown.vue'
import DateCard from './DateCard.vue'
import MyDayCard from './MyDayCard.vue'
import WfhEligibilityCard from './WfhEligibilityCard.vue'
import WfhDayCard from './WfhDayCard.vue'
import ManagerSummaryCard from './ManagerSummaryCard.vue'
import MyEvents from '../events/MyEvents.vue'
import MemoCard from './MemoCard.vue'
import TodaysMeetingsCard from './TodaysMeetingsCard.vue'
import PendingApprovalCount from './PendingApprovalCount.vue'
import AvailableRoomsCard from './AvailableRoomsCard.vue'
import AttendanceRequests from '../attendance/AttendanceRequests.vue'
import JoinBriefing from './JoinBriefing.vue'
import LeaveCarryForward from './LeaveCarryForward.vue'

import NoticeCard from './NoticeCard.vue'
import PendingTrainingsCard from './PendingTrainingsCard.vue'
import TrainingProgressCard from './TrainingProgressCard.vue'
import ActivePolls from '../polling/ActivePolls.vue'
import DocPanel from '../util/DocPanel.vue'

import html2canvas from 'html2canvas'

export default {
    components: {
        LeaveCarryForward,
        DateCard,
        MemoCard,
        MyDayCard,
        WfhEligibilityCard,
        WfhDayCard,
        ManagerSummaryCard,
        SickLeaveCountdown,
        MyEvents,
        TodaysMeetingsCard,
        PendingApprovalCount,
        AvailableRoomsCard,
        AttendanceRequests,
        JoinBriefing,
        NoticeCard,
        PendingTrainingsCard,
        TrainingProgressCard,
        ActivePolls,
        DocPanel,
    },
    data: () => ({
        loading: false,
        newHires: [],
        pendingTrainingCount: 0,
        trainingProgressCount: 0,
        wfhToday: false,
    }),
    methods: {
        async downloadPng(elementId) {
            if (!this.$can('hrms')) return

            const element = document.getElementById(elementId);
            if (!element) return;

            try {
                // save and override border radius
                const oldBorderRadius = element.style.borderRadius;
                element.style.borderRadius = "0";

                const canvas = await html2canvas(element, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: "#fff",
                });

                // restore border radius
                element.style.borderRadius = oldBorderRadius;

                // trigger download
                const dataUrl = canvas.toDataURL("image/png");
                const link = document.createElement("a");
                link.href = dataUrl;
                link.download = "new-hire-card.png";
                link.click();
            } catch (err) {
                console.error("Failed to capture image", err);
            }
        },
        getNewHires() {
            this.loading = true
            this.$axios.get(`/api/dashboard/getNewHires`).then((resp) => {
                this.newHires = resp.data
            }).finally(() => {
                this.loading = false
            })
        }
    },
    mounted() {
        this.getNewHires()
        console.log('Mounted, captureEl:', this.$refs.captureEl)
    }
}

</script>

<style scoped>
.new-hire-card {
    /* background: #5F0032;
  background: linear-gradient(180deg,rgba(95, 0, 50, 1) 0%, rgba(230, 161, 200, 1) 100%); */

    background: #ffc2e3;
    background: radial-gradient(circle, rgba(255, 194, 227, 1) 0%, rgba(95, 0, 50, 1) 100%);

    border-radius: 15px;

    color: white;
}

.welcome-banner {
    color: #5F0032;
}

.new-hire-card-small {
    background: #ffffff !important;

}

.capture-offscreen {
    position: absolute;
    left: -10000px;
    top: 0;
}
</style>
